// extracted by mini-css-extract-plugin
export var chip = "_eo-0";
export var filterDropdown = "_eo-5";
export var filterItem = "_eo-6";
export var icon = "_eo-1";
export var removeButton = "_eo-3";
export var removeIcon = "_eo-4";
export var separator = "_eo-2";